var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErlenmeyerFlask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.447,
    height: 24.422,
    viewBox: "0 0 15.447 24.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_163048",
    "data-name": "Grupo 163048",
    transform: "translate(20130.113 2077.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27347",
    "data-name": "Caminho 27347",
    d: "M191.312,144.456a1.539,1.539,0,0,1-.2-.741v-3.168a2.246,2.246,0,0,0-.307-4.471h-5.109a2.246,2.246,0,0,0-.307,4.471v3.193a1.538,1.538,0,0,1-.2.741l-4.343,7.076a2.182,2.182,0,0,0-.051,2.2,2.137,2.137,0,0,0,1.89,1.1H193.79a2.154,2.154,0,0,0,1.839-3.3ZM184.491,149l2.223-3.6a3.192,3.192,0,0,0,.46-1.66v-4.087a.905.905,0,0,0-.894-.894h-.588a.46.46,0,1,1,0-.919H190.8a.46.46,0,1,1,0,.919h-.588a.905.905,0,0,0-.894.894v4.062a3.127,3.127,0,0,0,.46,1.66l2.222,3.6h-7.511Z",
    transform: "translate(-20310.627 -2207.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27348",
    "data-name": "Caminho 27348",
    d: "M347.2,14.748a2.427,2.427,0,1,0,2.427-2.427,2.426,2.426,0,0,0-2.427,2.427Z",
    transform: "translate(-20469.709 -2089.328)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErlenmeyerFlask);
export default __webpack_public_path__ + "static/media/erlenmeyer-flask.3b4273ec7c9717e0d2c15856f0daa063.svg";
export { ForwardRef as ReactComponent };